"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonBranchesModal = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonBranchesModal = ({ isOpen, onClose }) => {
    const { client, businessContext, system } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const [branches, setBranches] = react_2.default.useState([]);
    const [loading, setLoading] = react_2.default.useState(false);
    const [switching, setSwitching] = react_2.default.useState();
    const [error, setError] = react_2.default.useState();
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    react_2.default.useEffect(() => {
        if (!isOpen || !(client === null || client === void 0 ? void 0 : client.getBranches))
            return;
        let active = true;
        setLoading(true);
        setError(undefined);
        client.getBranches()
            .then(data => { if (active) {
            setBranches(data);
            setLoading(false);
        } })
            .catch(err => { if (active) {
            setError(err instanceof Error ? err.message : 'Não foi possível carregar as filiais.');
            setLoading(false);
        } });
        return () => { active = false; };
    }, [isOpen, client]);
    async function select(branch) {
        if (!(client === null || client === void 0 ? void 0 : client.switchBranch) || switching)
            return;
        setSwitching(branch.id);
        setError(undefined);
        try {
            await client.switchBranch(branch.id);
            onClose();
            window.location.reload();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Não foi possível trocar a filial.');
        }
        finally {
            setSwitching(undefined);
        }
    }
    return (react_2.default.createElement(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "3xl", scrollBehavior: "inside" },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { bg: bg, rounded: "2xl" },
            react_2.default.createElement(react_1.ModalHeader, null, "Trocar de Filial"),
            react_2.default.createElement(react_1.ModalCloseButton, null),
            react_2.default.createElement(react_1.ModalBody, { pb: "6" },
                loading && react_2.default.createElement(react_1.Flex, { justify: "center", py: "10" },
                    react_2.default.createElement(react_1.Spinner, { color: "blue.500" })),
                error && react_2.default.createElement(react_1.Text, { color: "red.500", mb: "4" }, error),
                !loading && (react_2.default.createElement(react_1.Table, { size: "sm" },
                    react_2.default.createElement(react_1.Thead, null,
                        react_2.default.createElement(react_1.Tr, null,
                            react_2.default.createElement(react_1.Th, null, "C\u00F3digo"),
                            react_2.default.createElement(react_1.Th, null, "Nome"),
                            react_2.default.createElement(react_1.Th, null, "CPF/CNPJ"),
                            react_2.default.createElement(react_1.Th, null, "A\u00E7\u00E3o"))),
                    react_2.default.createElement(react_1.Tbody, null, branches.map(branch => {
                        var _a;
                        const current = String(branch.id) === String((_a = businessContext === null || businessContext === void 0 ? void 0 : businessContext.branchId) !== null && _a !== void 0 ? _a : '');
                        return (react_2.default.createElement(react_1.Tr, { key: `${system.id}:${branch.id}` },
                            react_2.default.createElement(react_1.Td, null, branch.id),
                            react_2.default.createElement(react_1.Td, null, branch.name),
                            react_2.default.createElement(react_1.Td, null, branch.document || '-'),
                            react_2.default.createElement(react_1.Td, null, current ? react_2.default.createElement(react_1.Badge, { colorScheme: "green" }, "Filial atual") : (react_2.default.createElement(react_1.Button, { size: "sm", onClick: () => select(branch), isLoading: switching === branch.id }, "Selecionar")))));
                    }))))))));
};
exports.OktonBranchesModal = OktonBranchesModal;
//# sourceMappingURL=index.js.map